import { RegisterSessionEnum } from '@schooly/api';

export interface RegisterResolvablePeriod {
  id: string;
  // Read responses type this as a bare string in some generated views; the BE
  // only ever emits 'am' | 'pm', so it is narrowed to the enum in the map below.
  register_session?: RegisterSessionEnum | string | null;
}

/**
 * Builds a periodId -> register session lookup from the register_session tag
 * that read responses now carry. Periods without a tag are simply absent from
 * the map, so consumers keep using `map.get(id) ?? null`.
 */
export const resolveStructureRegisterSessions = (
  periods: RegisterResolvablePeriod[],
): Map<string, RegisterSessionEnum> => {
  const result = new Map<string, RegisterSessionEnum>();
  for (const period of periods) {
    if (period.register_session != null) {
      result.set(period.id, period.register_session as RegisterSessionEnum);
    }
  }
  return result;
};

export interface RegisterSessionChips {
  showLessonChip: boolean;
  sessionChipKey: string | null;
}
